import { useState, useEffect } from 'react';
import { questsData } from '../mockData';
import LoadingScreen from './LoadingScreen';

const Quests = () => {
  const [loading, setLoading] = useState(true);
  const [quests, setQuests] = useState({
    socialfi: [],
    gaming: []
  });

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        // Simulate API latency  
        await new Promise(resolve => setTimeout(resolve, 1000));

        // Simulate API call  
        setQuests(questsData);

      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) {
    return <LoadingScreen />;  
  }

  const QuestCard = ({ quest }) => (
    <div className="rounded-lg shadow px-4 py-2 flex justify-between items-center">
      <div>
        <h3 className="font-semibold">{quest.title}</h3>
        <p className="text-sm opacity-50">{quest.description}</p>
        <div className="my-2 flex flex-col items-start">
          <span className="text-sm font-medium">Reward:</span>
          <span className="text-sm text-white bg-[#fd00ca] rounded-xl px-2">{quest.reward}</span>
        </div>
      </div>
      <div className="flex items-center ms-4 text-[.8rem]">
        {quest.completed ? (
          <span className="bg-green-100 text-green-800 px-3 py-1 rounded-full text-sm">
            DONE
          </span>
        ) : (
          <button className="bg-[#fd00ca] border-2 uppercase text-white px-2 font-bold py-1 rounded-lg">
            Start
          </button>
        )}
      </div>
    </div>
  );

  return (
    <div className="p-4">
      <h1 className="section-title mb-6">Quests</h1>

      <section className="mb-8">
        <div className="flex justify-start">
          <h2 className="text-md title bg-[#9087FF66] uppercase p-2 rounded-t-lg">SocialFi Tasks</h2>
        </div>
        <div className="border-2 rounded-b-2xl rounded-r-2xl border-[#ffcc5a] bg-[#481C8E]">
          {quests.socialfi.map((quest) => (
            <QuestCard key={quest.id} quest={quest} />
          ))}
        </div>
      </section>

      <section>
        <div className="flex justify-start">
          <h2 className="text-md title bg-[#9087FF66] uppercase p-2 rounded-t-lg">Gaming Quests</h2>
        </div>
        <div className="border-2 rounded-b-2xl rounded-r-2xl border-[#ffcc5a] bg-[#481C8E]">
          {quests.gaming.map((quest) => (
            <QuestCard key={quest.id} quest={quest} />
          ))}
        </div>
      </section>
    </div>
  );
};

export default Quests;  
